import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {OrderDeadlines} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: 'app-edit-order-deadlines',
  templateUrl: './edit-order-deadlines.component.html',
  styleUrl: './edit-order-deadlines.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditOrderDeadlinesComponent {
  @Input() deadlines: OrderDeadlines;
  @Input() header: string;
}
